import React from 'react';
import { TaskCategory } from '../types';
import CategoryCard from './CategoryCard';
import EmptyState from '../../../UI/EmptyState';
import styles from '../../../../styles/PointScheme.module.css';

interface CategoryListProps {
  categories: TaskCategory[];
  onEdit: (category: TaskCategory) => void;
  onDelete: (categoryId: string) => void;
  onAddNew: () => void;
  isGroupSpecific?: boolean;
  canEdit?: (category: TaskCategory) => boolean;
  canDelete?: (category: TaskCategory) => boolean;
  canAddNew?: boolean;
}

const CategoryList: React.FC<CategoryListProps> = ({ 
  categories, 
  onEdit, 
  onDelete, 
  onAddNew,
  isGroupSpecific = false,
  canEdit,
  canDelete,
  canAddNew = true
}) => {
  if (categories.length === 0) {
    return (
      <EmptyState
        image="/images/notasks.png"
        title={isGroupSpecific ? 'No Group Point Schemes Created' : 'No Global Point Schemes Created'}
        description={
          isGroupSpecific 
            ? 'Create point schemes specific to this group. These schemes will only be available for tasks in this group.'
            : 'Create global point schemes that will be available to all groups. These schemes can be used as templates for group-specific configurations.'
        }
        action={
          canAddNew
            ? {
                label: isGroupSpecific ? 'Create Your First Group Scheme' : 'Create Your First Global Scheme',
                onClick: onAddNew
              }
            : undefined
        }
      />
    );
  }

  return (
    <div className={styles.categoryList}>
      {categories.map(category => (
        <CategoryCard
          key={category.id}
          category={category}
          onEdit={onEdit}
          onDelete={onDelete}
          canEdit={canEdit ? canEdit(category) : true}
          canDelete={canDelete ? canDelete(category) : true}
        />
      ))}
    </div>
  );
};

export default CategoryList;
